import { useText } from '../context/TextContext';
import { formatDate } from '../utils/date';
import { AdvancedButton } from './AdvancedButton';
import Gravatar from './Gravatar';

export interface ActionLogItem {
    text: string;
    date: Date;
    email?: string;
    onEdit?: () => void;
    onDelete?: () => void;
}

interface ActionLogProps {
    actions: ActionLogItem[];
    className?: string;
}

export default function ActionLog({ actions, className }: ActionLogProps) {
    const text = useText();

    const sorted = [...actions].sort((a, b) => b.date.getTime() - a.date.getTime());
    return (
        <div className={className}>
            <div className='d-flex flex-column gap-2'>
                {sorted.map((action, ix) => (
                    <div key={ix} className='d-flex flex-column'>
                        <div className='d-flex align-items-center gap-2'>
                            {action.email && <Gravatar identifier={action.email} size='xs' />}
                            {action.email && <span className='text-muted small'>{action.email}</span>}
                            <div>{action.text}</div>
                        </div>
                        <div className='text-muted small'>{formatDate(action.date)}</div>
                        {(action.onEdit || action.onDelete) && (
                            <div className='d-flex gap-2'>
                                {action.onEdit && (
                                    <AdvancedButton variant="link" size="sm" className="p-0 text-muted" onClick={action.onEdit}
                                    >
                                        {text.edit}
                                    </AdvancedButton>
                                )}
                                {action.onDelete && (
                                    <AdvancedButton variant="link" size="sm" className="p-0 text-muted" onClick={action.onDelete}>
                                        {text.delete}
                                    </AdvancedButton>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
